<div class="product-catalog-search-box">
  <ng-select
    #productSelect
    [items]="updatedProducts"
    [clearable]="true"
    [typeahead]="searchInput$"
    [formControl]="productControl"
    placeholder="Search by product name"
    (change)="onProductSelection($event)"
    (search)="onSearch($event.term)"
    (clear)="onClear()"
    [loading]="loading"
    bindLabel="productName"
    [compareWith]="compareProducts"
    i18n-placeholder
    [inputAttrs]="{
      autoComplete: 'off',
      'aria-label': 'Product Catalog Search Input',
    }"
  >
    <ng-template ng-option-tmp let-item="item">
      <ng-container
        *ngIf="item.id === 'type-to-search' || item.id === 'not-found'; else extraOrProductOption"
      >
        <div [attr.disabled]="true" (click)="$event.stopPropagation()">
          <span *ngIf="item.id === 'type-to-search'" i18n>Type to search...</span>
          <div *ngIf="item.id === 'not-found'" class="not-found-message">
            <span class="not-found-icon"
              ><i class="fa-solid fa-circle-question has-text-primary pr-2"></i
            ></span>
            <span i18n class="not-found-text"
              >No results. Select “Add to product catalog” or manually enter product details to
              proceed with sale.</span
            >
          </div>
        </div>
      </ng-container>

      <ng-template #extraOrProductOption>
        <ng-container
          *ngIf="item.id === 'add-to-catalog' || item.id === 'manual-entry'; else productOption"
        >
          <a *ngIf="item.id === 'add-to-catalog'">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span class="ml-2" i18n>Add to product catalog</span>
          </a>
          <a *ngIf="item.id === 'manual-entry'">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span class="ml-2" i18n>Manually enter product</span>
          </a>
        </ng-container>

        <ng-template #productOption>
          <ng-container *ngIf="item.id !== 'load-more'">
            <div class="columns">
              <div
                class="column has-white-space-normal has-text-word-break"
                [ngClass]="{ 'pb-0': isDeviceMobile$ | async }"
              >
                {{ item?.name }}
              </div>
              <div
                class="column has-white-space-normal has-text-word-break"
                [ngClass]="{ 'pb-0': isDeviceMobile$ | async }"
              >
                <span class="has-text-grey" i18n>Sku Id:</span>
                {{ item?.sku }}
              </div>
              <div class="column">
                <span class="has-text-grey" i18n>Price:</span> {{ item.currency }}
                {{ item.price | number : '1.2-2' }}
              </div>
            </div>
          </ng-container>

          <div *ngIf="item.id === 'load-more'" (click)="$event.stopPropagation()">
            <a *ngIf="!loading" (click)="onLoadMore()">
              <span class="ml-2" i18n>Load more</span>
            </a>
            <span *ngIf="loading" class="ml-2" i18n>Loading...</span>
          </div>
        </ng-template>
      </ng-template>
    </ng-template>
  </ng-select>
</div>
